module.exports = __webpack_public_path__ + "static/media/no-NO.0154fde4.md";